export const START_YEAR = 1901;
// TODO: we need to remove it to make height customizable
export const MONTH_ITEM_HEIGHT = 40;